import { LicenceId } from '@ps/platform-message-framework/common/LicenceId';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import FeePromptDefault from './FeePromptDefault/FeePromptDefault';
import FeePromptRO from './FeePromptRO/FeePromptRO';

export interface Props {
  onConfirm: () => void;
  onClose: () => void;
}

const DepositFeePrompt: React.FC<Props> = ({ onConfirm, onClose }) => {
  const license = useSelector(select.account.getLicense);

  return license === LicenceId.ROMANIA ? (
    <FeePromptRO onConfirm={onConfirm} onClose={onClose} />
  ) : (
    <FeePromptDefault onConfirm={onConfirm} />
  );
};

export default DepositFeePrompt;
